import notificationSound from "../assets/sounds/chat/message-recive.mp3";

// To use a different sound, drop a file in src/assets/sounds/ and change the import above.
const MUTE_KEY = "notificationSound"; // set to "off" in localStorage to mute
const MIN_GAP_MS = 1500; // several pushes at once should ring once

let audio = null;
let lastPlayed = 0;

/**
 * Plays the notification sound. Never throws: browsers refuse audio until the user has
 * interacted with the page once, and that must not break notification handling.
 */
export function playNotificationSound() {
  try {
    if (localStorage.getItem(MUTE_KEY) === "off") return;
  } catch {
    /* storage unavailable: play anyway */
  }
  const now = Date.now();
  if (now - lastPlayed < MIN_GAP_MS) return;
  lastPlayed = now;
  try {
    audio = audio || new Audio(notificationSound);
    audio.currentTime = 0;
    audio.play().catch(() => {});
  } catch {
    /* no audio support */
  }
}

/** The chat page already plays its own sound for messages, so don't double up there. */
export const chatPageHandlesSound = () => window.location.pathname.startsWith("/communication/chat");
